export const ACTIVE_ATTACHED_ROLES_FILTERS = { status: ["active"], archived: false };

// Role list API omits archived roles unless `archived` is sent; archived=true + status ORs them in.
export const ALL_ATTACHED_ROLES_FILTERS = {
  status: ["draft", "active", "inactive", "retired"],
  archived: true,
};

export function getAttachedRolesList(data) {
  if (!data) return [];
  if (Array.isArray(data.attached_roles_data)) return data.attached_roles_data;
  if (Array.isArray(data.attached_roles)) return data.attached_roles;
  if (Array.isArray(data.info?.attached_roles_data)) return data.info.attached_roles_data;
  if (Array.isArray(data.info?.attached_roles)) return data.info.attached_roles;
  return [];
}

export function getActiveAttachedRolesList(data) {
  return getAttachedRolesList(data).filter((role) => role?.status === "active");
}

export function resolveActiveAttachedRolesCount(data) {
  if (!data) return undefined;

  const candidates = [
    data.active_attached_role_count,
    data.active_attached_roles_count,
    data.active_role_attachment_count,
    data.attachments_count?.active_role,
    data.info?.active_attached_role_count,
    data.info?.active_attached_roles_count,
    data.info?.active_role_attachment_count,
    data.info?.attachments_count?.active_role,
  ];

  for (const value of candidates) {
    if (value == null || value === "") continue;
    const count = Number(value);
    if (!Number.isNaN(count)) return count;
  }

  const roles = getAttachedRolesList(data);
  if (roles.length > 0) {
    return getActiveAttachedRolesList(data).length;
  }

  return undefined;
}

export function getActiveAttachedRolesDisplayProps(data) {
  const activeRoles = getActiveAttachedRolesList(data);
  const total = resolveActiveAttachedRolesCount(data) ?? 0;
  const firstActive = activeRoles[0];

  return {
    roleName: firstActive ? firstActive.name || firstActive.role_name || "" : "",
    totalRoles: total,
  };
}
